import { Logger } from '../../utils/Logger'
import { WidgetsApi } from '../Api/WidgetsApi'
import { MqttClient } from './MqttClient'

const logger: Logger = new Logger('MQTTActions')

export const connect = (listener?: (message: string, topic: string) => void): void => {
    const onSuccess = (): void => {
        logger.debug('[connect]', 'onSuccess MQTT connect')
    }

    if (MqttClient.isConnected()) {
        if (listener) {
            MqttClient.addMessageListener(listener)
        }
    } else {
        MqttClient.unsubscribeAll()
        if (!MqttClient.isConnected()) {
            WidgetsApi.getMqttAuth()
                .then(s => {
                    MqttClient.setConfig(s)
                    MqttClient.onConnect = onSuccess
                    if (listener) {
                        MqttClient.addMessageListener(listener)
                    }
                    MqttClient.connect()
                })
                .catch((error: any) => {
                    logger.error('[connect]', '[AuthApi]', error)
                })
        }
    }
}

export const disconnect = (): void => {
    MqttClient.disconnect()
}

export const subscribe = (topics: string[]): void => {
    MqttClient.subscribe(topics)
}

export const unsubscribe = (topics?: string[]): void => {
    if (topics) {
        MqttClient.unsubscribe(topics)
    } else {
        MqttClient.unsubscribeAll()
    }
}

export const removeMessageListener = (listener: (message: string, topic: string) => void): void => {
    MqttClient.removeMessageListener(listener)
}
